function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import { GalleryComponent } from '../galleryComponent';

var TextItem = /*#__PURE__*/function (_GalleryComponent) {
  _inheritsLoose(TextItem, _GalleryComponent);

  var _super = _createSuper(TextItem);

  function TextItem() {
    return _GalleryComponent.apply(this, arguments) || this;
  }

  var _proto = TextItem.prototype;

  _proto.getTextDimensions = function getTextDimensions() {
    var _this$props = this.props,
        style = _this$props.style,
        styleParams = _this$props.styleParams,
        cubeRatio = _this$props.cubeRatio;
    var isVerticalItem = style.ratio < cubeRatio - 0.01; //text dimensions include scaling

    var textHeight = (isVerticalItem ? style.height / style.maxHeight : style.width / style.maxWidth) * style.maxHeight;
    var marginTop = styleParams.cubeType === 'fit' ? 0 : (style.height - textHeight) / 2;
    var transform = 'translate(0, 0) scale(' + (isVerticalItem ? style.height / style.maxHeight : style.width / style.maxWidth) + ')';
    return {
      marginTop: marginTop,
      width: style.maxWidth + 'px',
      height: style.maxHeight + 'px',
      transformOrigin: '0 0',
      WebkitTransform: transform,
      MsTransform: transform,
      OTransform: transform,
      transform: transform
    };
  };

  _proto.componentWillMount = function componentWillMount() {
    this.props.actions.setItemLoaded();
  };

  _proto.processInnerhtml = function processInnerhtml(html) {
    // Remove html class name from inner html elements
    // In older version of the text editor we used font themes (set as classes). Without the iframe it clashes with Santa's css
    try {
      return html.replace(/class="font_\d+"/gm, '');
    } catch (e) {
      return html;
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        id = _this$props2.id,
        styleParams = _this$props2.styleParams,
        html = _this$props2.html,
        style = _this$props2.style,
        actions = _this$props2.actions,
        imageDimensions = _this$props2.imageDimensions;
    var processedHtml = this.processInnerhtml(html);
    var dimensions = this.getTextDimensions();
    var htmlParam = {
      dangerouslySetInnerHTML: {
        __html: processedHtml
      }
    };
    var changeBgColor = {
      style: Object.assign(dimensions, styleParams.cubeType === 'fit' ? {
        backgroundColor: style.bgColor
      } : {})
    };

    var attributes = _objectSpread({}, htmlParam, {}, changeBgColor);

    var itemContentStyle = {
      height: imageDimensions ? imageDimensions.height : 'inherit',
      backgroundColor: styleParams.cubeType !== 'fit' ? style.bgColor : 'inherit'
    };

    if (imageDimensions && imageDimensions.borderRadius) {
      itemContentStyle.borderRadius = imageDimensions.borderRadius;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: 'gallery-item-content',
      style: itemContentStyle
    }, /*#__PURE__*/React.createElement("div", _extends({
      className: 'gallery-item-visible gallery-item gallery-item-loaded text-item',
      key: 'item-text-' + id,
      onTouchStart: actions.handleItemMouseDown,
      onTouchEnd: actions.handleItemMouseUp,
      "data-hook": "text-item"
    }, attributes)));
  };

  return TextItem;
}(GalleryComponent);

export { TextItem as default };